var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("This is not the page you're looking for")]),_c('img',{attrs:{"src":require("../assets/Img_3181.jpg"),"alt":""}})])}]

export { render, staticRenderFns }